export type ScaleFunction = (x: number) => number;

export const getLinearScale =
    (x1: number, x2: number, y1: number, y2: number): ScaleFunction =>
    (x) =>
        ((x - x1) * (y2 - y1)) / (x2 - x1) + y1;
